import dayjsImport from "./auth-service-tools36.js";

function isDateValid(_ref) {
  let {
    date,
    maxDate,
    minDate
  } = _ref;

  if (date == null) {
    return false;
  }

  if (Number.isNaN(date.getTime())) {
    return false;
  }

  if (maxDate && dayjsImport(date).isAfter(maxDate, "date")) {
    return false;
  }

  if (minDate && dayjsImport(date).isBefore(minDate, "date")) {
    return false;
  }

  return true;
}

export { isDateValid };